import axios from 'axios';

function coreApiBase() {
    const b = process.env.VUE_APP_API_URL_CORE || '';
    return b.replace(/\/?$/, '/');
}

function bearerHeaders() {
    const token = (typeof localStorage !== 'undefined' && localStorage.getItem('access_token')) || '';
    return token ? { Authorization: `Bearer ${token}` } : {};
}

let AuthService = {};

(function () {
    const endpoint = 'auth';

  this.log_in = function (username, password, recaptchaToken) {
    const url = `${process.env.VUE_APP_URL}/oauth2/token/`;
    const data = new FormData();
    data.append('client_id', `${process.env.VUE_APP_CLIENT_ID}`);
    data.append('client_secret', `${process.env.VUE_APP_CLIENT_SECRET}`);
    data.append('username', username);
    data.append('password', password);
    data.append('grant_type', 'password');
    if (recaptchaToken) {
      data.append('recaptcha_token', recaptchaToken);
    }

    return axios.post(url, data)
  };

    this.refresh_access = function (token) {
        const url = `${process.env.VUE_APP_URL}/oauth2/token/`;
        const data = new FormData();
        data.append('client_id', `${process.env.VUE_APP_CLIENT_ID}`);
        data.append('client_secret', `${process.env.VUE_APP_CLIENT_SECRET}`);
        data.append('refresh_token', token);
        data.append('grant_type', 'refresh_token');
        return axios.post(url, data)
    };

    /** Paso 1 recuperación (público): solicita código al correo. Requiere cabecera shp (axios ya la envía). */
    this.passwordRecoveryRequestCode = function (email, recaptchaToken) {
        const url = `${coreApiBase()}password/recovery/request-code/`;
        return axios.post(url, {
            email,
            recaptcha_token: recaptchaToken || '',
        });
    };

    /** Paso 2 recuperación (público): código + nueva contraseña. */
    this.passwordRecoveryConfirm = function (email, code, newPassword, confirmPassword, recaptchaToken) {
        const url = `${coreApiBase()}password/recovery/confirm/`;
        return axios.post(url, {
            email,
            code,
            new_password: newPassword,
            confirm_password: confirmPassword,
            recaptcha_token: recaptchaToken || '',
        });
    };

    /** Sesión iniciada: envía código (purpose change | reset). */
    this.passwordLoggedRequestCode = function (purpose, recaptchaToken) {
        const url = `${coreApiBase()}password/logged/request-code/`;
        return axios.post(
            url,
            { purpose, recaptcha_token: recaptchaToken || '' },
            { headers: bearerHeaders() }
        );
    };

    this.passwordLoggedConfirmChange = function (oldPassword, newPassword, confirmPassword, code, recaptchaToken) {
        const url = `${coreApiBase()}password/logged/confirm-change/`;
        return axios.post(
            url,
            {
                old_password: oldPassword,
                new_password: newPassword,
                confirm_password: confirmPassword,
                code,
                recaptcha_token: recaptchaToken || '',
            },
            { headers: bearerHeaders() }
        );
    };

    this.passwordLoggedConfirmReset = function (newPassword, confirmPassword, code, recaptchaToken) {
        const url = `${coreApiBase()}password/logged/confirm-reset/`;
        return axios.post(
            url,
            {
                new_password: newPassword,
                confirm_password: confirmPassword,
                code,
                recaptcha_token: recaptchaToken || '',
            },
            { headers: bearerHeaders() }
        );
    };

    /** @deprecated usar passwordRecoveryRequestCode; alias por compatibilidad. */
    this.recoveryPass = function (email, recaptchaToken) {
        return this.passwordRecoveryRequestCode(email, recaptchaToken);
    };

    this.registerUser = function (email, password, confirmPassword, recaptchaToken) {
        const url = `${process.env.VUE_APP_API_URL_CORE}crear-usuario`;
        let data = {"email": email, "password": password, "confirmPassword": confirmPassword};
        if (recaptchaToken) {
            data.recaptcha_token = recaptchaToken;
        }
        return axios.post(url, data)
    };

    this.getUser = function (username) {
        const url = `${process.env.VUE_APP_API_URL_CORE}getuser`;
        let data = {"username": username};
        return axios.post(url, data)
    };

    this.getUserByToken = function () {
        const token = (typeof localStorage !== 'undefined' && localStorage.getItem('access_token')) || '';
        const url = `${process.env.VUE_APP_API_URL_CORE}getuser`;
        return axios.get(url, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
    };

    /** Actualiza nombre, apellido paterno y correo del usuario autenticado (OAuth). */
    this.updateProfileSelf = function (payload) {
        const url = `${coreApiBase()}profile/self-update/`;
        return axios.post(url, payload, { headers: bearerHeaders() });
    };


    this.changePass = function (username, password) {
        const url = `${process.env.VUE_APP_API_URL_CORE}changepass`;
        let data = {"username": username, "password": password};
        return axios.post(url, data)
    }

    this.deleteuser = function (username) {
        const url = `${process.env.VUE_APP_API_URL_CORE}deleteuser`;
        let data = {"username": username};
        return axios.post(url, data)
    }

   this.getUserDetail = function (username, password) {
        return new Promise((resolve, reject) => {
            const LOGIN_URL = `${process.env.VUE_APP_API_URL_TIENDA}${endpoint}`;
            const params = {
                username: username,
                password: password,
            };

            axios.post(LOGIN_URL, params).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error)
            });
        });
    };

    this.logOut = function () {
        return new Promise((resolve, reject) => {
            const LOGIN_URL = `${process.env.VUE_APP_API_URL_TIENDA}${endpoint}`;
            axios.get(LOGIN_URL).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error)
            });
        });
    };
}).apply(AuthService);

export default AuthService;
